/* models/tickers/basic_ticker.js */ function _(require, module, exports) {
    const adaptive_ticker_1 = require(103) /* ./adaptive_ticker */;
    class BasicTicker extends adaptive_ticker_1.AdaptiveTicker {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.BasicTicker = BasicTicker;
    BasicTicker.__name__ = "BasicTicker";
}
